module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Checkbox 复选框")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<label class=\"input-control checkbox\">\n  <input type=\"checkbox\" checked>\n  <span class=\"check\"></span>\n  <span class=\"caption\">苹果</span>\n</label>\n<label class=\"input-control checkbox\">\n  <input type=\"checkbox\">\n  <span class=\"check\"></span>\n  <span class=\"caption\">香蕉</span>\n</label>\n")])]), _vm._v(" "), _c('h5', {
    staticClass: "fg-gray"
  }, [_vm._v("Disabled状态")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("\n<label class=\"input-control checkbox\">\n  <input type=\"checkbox\" checked disabled>\n  <span class=\"check\"></span>\n  <span class=\"caption\">喜欢</span>\n</label>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("你最喜欢的水果：")]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("苹果")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("香蕉")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("梨子")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("橘子")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("你喜欢我吗：")]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("喜欢")])]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("不喜欢")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e8b895"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/checkbox.vue
// module id = 399
// module chunks = 1